module.exports = __webpack_public_path__ + "static/media/inventory-management.e0939308.svg";